/*
 * @Author: xl
 * @Date: 2021-11-04 09:48:49
 * @LastEditTime: 2023-04-18 13:09:42
 * @LastEditors: 迟长志 943512491@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/page/about/index.tsx
 */
import React from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, message, Row, TimePicker, } from 'antd';
import { PlusOutlined, PlusCircleOutlined } from '@ant-design/icons';
import './index.css';
import { layoutType, query, ActiveSessionListItem, CommodityListItem } from "./api";
import moment from 'moment';
import { index } from 'mathjs';
import Luckysheet from './luckysheet'

const layout: layoutType = {
    labelCol: { span: 2 },
    wrapperCol: { span: 5 },
};
const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

interface IndexState {
    query: query
}

export class About extends React.Component<any, IndexState>{
    public constructor(props: any) {
        super(props);
        this.state = {
            query: {
                activeName: '',
                activeDate: '',
                purchaseLimitation: false,
                purchaseLimitationNumber: '',
                overtime: '',
                activeSessionList: []
            },
        }
    }

    public async componentDidMount() {
        const { query } = this.state;
        const activeSessionListItem: ActiveSessionListItem = {
            key: 0,
            startTime: '',
            continueTime: '',
            commodityList: []
        }
        query.activeSessionList = [activeSessionListItem];
        this.setState({
            query
        })
    }

    render() {
        let { query } = this.state;
        return < Luckysheet />
        return (
            <div className='activity-creat'>

                <p className='headline-style'>活动设置</p>
                <Form
                    {...layout}
                    name="basic"
                    initialValues={{ remember: true }}
                    onFinish={() => {
                        console.log(this.state.query)
                    }}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="活动名称"
                        name="activeName"
                        rules={[{ required: true, message: '请输入正确的活动名称!' }]}
                    >
                        <Input value={query.activeName} onChange={e => this.setState({
                            query: {
                                ...this.state.query,
                                activeName: e.target.value
                            }
                        })} />
                    </Form.Item>
                    <Form.Item
                        label="活动日期"
                        name="activeDate"
                        rules={[{ required: true, message: '请选择正确活动日期!' }]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            value={query.activeDate ? moment(query.activeDate) : null}
                            onChange={(date, dateString) => this.setState({
                                query: {
                                    ...this.state.query,
                                    activeDate: dateString
                                }
                            })}
                        />
                    </Form.Item>
                    <Form.Item
                        label="开启限购"
                    >
                        <Input.Group compact>
                            <Form.Item
                                name={['purchaseLimitation', 'purchaseLimitationNumber']}
                                style={{ width: '40%', margin: 0 }}
                            >
                                <Checkbox
                                    value={query.purchaseLimitation} onChange={e => this.setState({
                                        query: {
                                            ...this.state.query,
                                            purchaseLimitation: e.target.value
                                        }
                                    })}
                                >开启限购</Checkbox>
                            </Form.Item>
                            <Form.Item
                                name={['purchaseLimitation', 'purchaseLimitationNumber']}
                                noStyle
                            >
                                <InputNumber style={{ width: '60%' }} min={1} placeholder={'请输入限购数量'} value={query.purchaseLimitationNumber} onChange={e => this.setState({
                                    query: {
                                        ...this.state.query,
                                        purchaseLimitationNumber: e
                                    }
                                })} />
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>
                    <Form.Item
                        label="订单取消"
                        name="overtime"
                    >
                        <span>买家</span>
                        <InputNumber style={{ width: '50px' }} min={1} max={120} value={query.overtime} onChange={e => this.setState({
                            query: {
                                ...this.state.query,
                                overtime: e
                            }
                        })} />
                        <span>分钟未支付订单，订单自动取消</span>
                    </Form.Item>
                    <p className='headline-style'>商品设置</p>
                    {/* 场次循环 */}
                    {query && query.activeSessionList && query.activeSessionList.map((item: ActiveSessionListItem, index: number) => {
                        return this.activeSession(item, index)
                    })}
                    <div className='activeSession' style={{ textAlign: 'center' }}>
                        <Button type='link' icon={<PlusCircleOutlined />} onClick={() => {
                            this.addActive()
                        }} >添加场次</Button>
                    </div>
                    {/* 强制居中不用Form.Item  */}
                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit" style={{ marginRight: 80 }}>
                            保存
                        </Button>
                        <Button htmlType="button"
                        // onClick={onReset}
                        >
                            取消
                        </Button>
                    </Form.Item>
                </Form>

            </div>
        )
    }
    /**
     * @description: 新增场次 新增之前校验上一场次信息是否完整
     * @param {*}
     * @return
     */
    private addActive = () => {
        const { query } = this.state;
        let activeSessionList = query.activeSessionList;
        if (!SessionVerification(activeSessionList)) {
            return false
        }
        const activeSessionListIte = {
            key: query.activeSessionList && query.activeSessionList.length + 1,
            startTime: '',
            continueTime: '',
            commodityList: []
        }
        activeSessionList.push(activeSessionListIte);
        this.setState({
            query
        })
    }

    /**
     * @description: 删除场次最后一场禁止删除
     * @param {number} index
     * @return {*}
     */
    private delActive = (index: number) => {
        const { query } = this.state;
        let activeSessionList = query.activeSessionList;
        activeSessionList.splice(index, 1);
        this.setState({
            query
        })
    }

    /**
     * @description: 渲染场次信息 回填的话注意valu值
     * @param {ActiveSessionListItem} item
     * @param {number} index
     * @return {*}
     */
    private activeSession = (item: ActiveSessionListItem, index: number) => {
        const { query } = this.state;
        let activeSessionList = query.activeSessionList;
        return (
            <div className='activeSession' key={item.key}>
                <Row className='activeSession-row'>
                    <Col span={2} className='activeSession-title1'><span>开始时间：</span></Col>
                    <Col span={18}> <TimePicker className='activeSession-input' size="large" onChange={(time, timeString) => {
                        item.startTime = timeString;
                        activeSessionList.splice(index, 1, item)
                        this.setState({ query })
                    }} /></Col>
                </Row>
                <Row className='activeSession-row'>
                    <Col span={2} className='activeSession-title1'><span>持续时间：</span></Col>
                    <Col span={18}><InputNumber className='activeSession-input' min={1} max={72} onChange={(value) => {
                        item.continueTime = value;
                        activeSessionList.splice(index, 1, item)
                        this.setState({ query })
                    }} /></Col>
                </Row>
                <Row className='activeSession-row'>
                    <Col span={2} className='activeSession-title1'><span>选择商品：</span></Col>
                    <Col span={18}>
                        <Row style={{ width: '100%' }}>
                            <Col style={{ width: '100%' }}>
                                <Row gutter={[12, 12]}>
                                    {item && item.commodityList.map((itemRow: CommodityListItem, i: number) => {
                                        return this.commodityList(index, itemRow, i)
                                    })}
                                </Row>
                            </Col>
                            <Col>
                                <Button icon={<PlusOutlined />} onClick={() => {
                                    this.addCommodity(index)
                                }} >选择商品</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row >
                <Button className='activeSessionDelete' onClick={() => { this.delActive(index) }}>删除</Button>
            </div >
        )
    }

    /**
     * @description: 根据场次增加相关的商品
     * @param {number} index
     * @return {*}
     */
    private addCommodity = (index: number) => {
        const { query } = this.state;
        let activeSessionList: Array<ActiveSessionListItem> = query.activeSessionList;
        const obj = { // 模拟数据真实数据根据所需格式回填即可
            id: activeSessionList[index].commodityList.length,
            name: '名字',
            commodity: 1,
            inventory: 2
        }
        activeSessionList[index].commodityList.push(obj);
        this.setState({
            query
        })
    }

    private delCommodity = (index: number, i: number) => {
        const { query } = this.state;
        let activeSessionList: Array<ActiveSessionListItem> = query.activeSessionList;
        activeSessionList[index].commodityList.splice(i, 1);
        this.setState({
            query
        })
    }


    /**
     * @description: 场次配置的商品信息
     * @param {CommodityListItem} item
     * @param {number} index
     * @param {number} i
     * @return 
     */
    private commodityList = (index: number, item: CommodityListItem, i: number) => {
        return (
            <Col span={10} key={item.id + '_' + i}>
                <div className='commodityList-item'>
                    <img src="" alt="" className='commodityList-img' />
                    <div className='commodityList-info'>
                        <p>这是名称</p>
                        <p>秒杀价：666～999</p>
                        <p>秒杀库存：88～99</p>
                    </div>
                    <div>
                        <Button type="link">编辑</Button>
                        <Button type="link" danger onClick={() => { this.delCommodity(index, i) }} >删除</Button>
                    </div>
                </div>

            </Col >
        )
    }


}

/**
 * @description: 校验场次信息是否填写
 * @param {Array} params
 * @return {*}
 */
function SessionVerification(params: Array<ActiveSessionListItem>) {
    for (const iterator of params) {
        if (iterator.startTime === '') {
            message.warning('请选择场次开始时间！')
            return false
        } else if (iterator.continueTime === '') {
            message.warning('请选择场次持续时间！')
            return false
        } else if (iterator.commodityList.length === 0) {
            message.warning('请选择场次配置的商品！')
            return false
        }
    }
    return true
}